// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1VSNn","title":"AfterFrontImage_title__H8Iom"};